module.exports = __webpack_public_path__ + "img/download_phone.0b1a7a04.png";